import * as sonbp from "sonbp";

/**
* ポスカ用テキストアイテムのコンテンツエディター
* @summary 拡大操作中は文字縁を透明で描画のため、拡大操作中用のアイテム保持を追加している。
*/
export class poscaVitem extends sonbp.listener.editor.vitem {

	/**
	 * コンストラクタ
	 * @param itemRef アイテム参照情報
	 */
	public constructor(item: sonbp.object.baseItem) {

		super(item);
	}

	/**
	 * アイテム参照情報（フチなしテキスト用）
	 */
	public itemEdge: sonbp.object.groupItem;
}
